import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import RouterLink from '@/se/components/RouterLink';

const ReleaseNotesListItem = () => (
  <ListItem button component={RouterLink} to="/release-notes">
    <ListItemIcon>
      <InfoOutlined />
    </ListItemIcon>
    <ListItemText primary="About" />
  </ListItem>
);

export default ReleaseNotesListItem;
